import { gql } from '@apollo/client';

const GET_TOPICS = gql`
  query Topics($workspaceId: ID!, $sorter: TopicSorter) {
    topics(workspaceId: $workspaceId, sorter: $sorter) {
      id
      name
      createdAt
      assignedUsers {
        id
        email
        firstName
        lastName
        pictureURL
        activityStatus
      }
    }
  }
`;

export default GET_TOPICS;
